export default {
    // 企业类型
    orgType: {
        "0": "服务企业",
        "1":"客户企业"
    },
    // 企业状态
    orgState: {
        "0": "停用",
        "1": "正常",
        "2":"到期"
    },
    //用户状态
    userState: {
        "0": "停用",
        "1": "正常",
        "2": "待审核",
        "3": "驳回"
    }
}